export default "__VITE_ASSET__8c9756d9__"